import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

interface TabsProps extends BoxProps {
  fullWidth?: boolean;
}

const Tabs: React.FC<TabsProps> = ({ fullWidth, ...rest }) => {
  return <Box {...rest} className={cx(styles['tabs'], { [styles['tabs--full-width']]: fullWidth })} />;
};

export default Tabs;
